import type { CSSProperties } from "react";

const Loading = (_props: { style?: CSSProperties }) => {
  return null;
};

export default Loading;
